const SERVICE_ACCOUNTS_ROLE_ALIASES = new Set(['serviceaccounts', 'serviceaccount']);

export function normalizeRoleName(name: string): string {
  return (name || '').toLowerCase().replace(/[\s_-]+/g, '');
}

export function isServiceAccountsRoleName(roleName: string): boolean {
  return SERVICE_ACCOUNTS_ROLE_ALIASES.has(normalizeRoleName(roleName));
}

export function isServiceAccountsCustomRole(
  roleType: string | undefined,
  roleName: string
): boolean {
  return roleType === 'CUSTOM' && isServiceAccountsRoleName(roleName);
}

export function getRoleNameFromUser(user: {
  role?: string | { name?: string };
} | null | undefined): string {
  if (!user) return '';
  if (user.role && typeof user.role === 'object' && user.role.name) {
    return user.role.name;
  }
  if (typeof user.role === 'string') {
    return user.role;
  }
  return '';
}

export function canAccessPermissionsManagement(
  user: { roleType?: string; role?: string | { name?: string } } | null | undefined,
  hasPermissionsRead: boolean
): boolean {
  if (!user) return false;
  if (user.roleType === 'GOD') return true;
  if (!hasPermissionsRead) return false;
  if (user.roleType !== 'CUSTOM') return true;

  return isServiceAccountsCustomRole(user.roleType, getRoleNameFromUser(user));
}

export function shouldShowPermissionsResourceForRole(role: {
  roleType?: string;
  name?: string;
}): boolean {
  if (role.roleType !== 'CUSTOM') return true;
  return isServiceAccountsRoleName(role.name || '');
}
